import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../../../shared/services/language.service';
import { GetCashApi } from '../../../../admin/action/components/crm/profile/services/get-cash-api-status.service';
import { UpdateCashApiCallbackUrl } from '../../services/update-cash-api-callback-url.service';
import { StepOneBase } from 'src/app/shared/product/stepOne';
import { AuthService } from 'src/app/shared/services/auth.service';
import { GetCurrenciesService } from 'src/app/shared/product/components/currency/getCurrencies.service';
import { ConfirmActionComponent, ConfirmDialogModel } from './confirmAction/confirmAction.component';
import { UpdateCashApi } from 'src/app/dashboard/admin/action/components/crm/profile/services/update-cash-api.service';
import { requestShopifyScript } from 'src/app/dashboard/admin/action/components/crm/profile/services/requestShopifyScript.service';
@Component({
  selector: 'app-cash-api',
  templateUrl: './cash-api.component.html',
  styleUrls: ['./cash-api.component.scss']
})
export class CashApiComponent extends StepOneBase implements OnInit {
  apiKey: string = "";
  callbackUrl: string = "";
  isUpdate: any;
  updatedPaymentOptions = []
  shopName : string ="";
  shopifyAccessToken: string = "";
  sc : any ;
  constructor(
    private router: Router,
    public dialog: MatDialog,
    private getCashApi: GetCashApi,
    private updateCashApiCallbackUrl: UpdateCashApiCallbackUrl,
    private snackBar: MatSnackBar,
    private translate: TranslateService,
    private languageService: LanguageService,
    protected getCurrencies : GetCurrenciesService,
    protected auth: AuthService,
    private updateCashApi: UpdateCashApi,
    private  shopScriptService : requestShopifyScript,
  ) {
    super(getCurrencies,auth);
  }

  async ngOnInit() {
    this.translate.use(localStorage.getItem('language'));
    this.languageService.languageUpdated.subscribe((lang) => {
      this.translate.use(lang);
    })
    const result = await this.getCashApi.make();
    if (!result.enabled) {
      this.router.navigate(["/"]);
    }

    this.apiKey = result.apiKey;
    this.callbackUrl = result.callbackURL || ""
    this.feesOnBuyerField.defaultValue = result.feesOnBuyerFlag
    this.splitFeesField.defaultValue = result.splitFees;
    this.VATOnSellerField.defaultValue = !result.VATOnSellerFlag
    this.productName = 'Event';
    this.shopName = result.shopName;
    this.shopifyAccessToken = result.shopifyAccessToken
    this.form = this.getForm(this.productName);
    this.stepForm = this.formValidator.createForm(this.form);
    this.fromControllers = this.stepForm;
    this.stepForm.markAsUntouched();
    this.stepForm.controls['Payment options'].valueChanges.subscribe(option => {
      this.updatedPaymentOptions = option
    })
  }

  copyInputMessage(text: any) {
    const selBox = document.createElement('textarea') as HTMLTextAreaElement;
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = text;
    document.body.appendChild(selBox);
    selBox.select();
    const success = document.execCommand('copy');
    document.body.removeChild(selBox);
    this.snackBar.open(
      this.translate.instant('Sellers.Products.CopiedToClipboard'),
      '',
      { duration: 2000 });

  }

  isValidURL(value: any) {
    try {
      const url = new URL(value);
      return url.protocol === "http:" || url.protocol === "https:";
    } catch {
      return false;
    }
  }

  async submit() {
    if (!this.isValidURL(this.callbackUrl)) return;

    this.updateCashApiCallbackUrl.setParams({
      url: this.callbackUrl,
      feesOnBuyerFlag: this.stepForm.controls['Do you want the fees to be on the buyer?'].value,
      VATOnSellerFlag: !this.stepForm.controls['Do you want the VAT to be on buyer?'].value,
      splitFees: this.stepForm.controls['Do you want the fees to be split between buyer and seller?'].value,
      paymentOptions: this.updatedPaymentOptions,
      shopName : this.shopName,
      shopifyAccessToken:this.shopifyAccessToken
    });
    await this.updateCashApiCallbackUrl.make();
  }

  showError() {
    if (this.callbackUrl.trim() == '')
      return false;
    return !this.isValidURL(this.callbackUrl)
  }
async requestScript(){
 const data =  await this.shopScriptService.make();
 this.sc = data
}
 confirmAction(): void {
    const dialogData = new ConfirmDialogModel();
    const dialogRef = this.dialog.open(ConfirmActionComponent, {
      maxWidth: "600px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe( async (dialogResult: boolean) => {
      if (dialogResult) {
        await this.updateCashApi.make();
        const result = await this.getCashApi.make();
        if (!result.enabled) {
          this.router.navigate(["/"]);
        }
        this.apiKey = result.apiKey;
      }
    });
  }
}
